import PlaceholderImage from 'images/no-image@2x.png';
//import {DAS_REGEX} from 'components/imaging/ResizedDasWebImage';

const Helpers = {
	replaceMissingUrls: (referenceList, list) => {
		return list.map((image, index) => {
			if (index < referenceList.length) {
				if (!image || PlaceholderImage === image) {
					return referenceList[index];
				}
			}
			return image;
		}).filter(x => !!x);
	},
};

const PropertyDetailImages = {
	list:  (propertyDetail) => {
		return propertyDetail.propertyPhotoList && propertyDetail.propertyPhotoList.length > 0 ? [...propertyDetail.propertyPhotoList] : [];
	},
	targetPropertyPhotoList: (propertyDetail) => {
		const propertyImages = PropertyDetailImages.list(propertyDetail);
		const images = propertyDetail.targetPhotoList && propertyDetail.targetPhotoList.length > 0 ? propertyDetail.targetPhotoList : propertyImages;
		const withoutBlanks = Helpers.replaceMissingUrls(propertyImages, images);
		return [...withoutBlanks, null, null].slice(0, 2);
	},
	reportSummaryPhotos: (propertyDetail) => {
		const images = PropertyDetailImages.list(propertyDetail);
		const selectedImages = propertyDetail.selectedImages || [];
		const defaults = [...images, null, null, null, null].slice(0, 4);
		const selected = [...selectedImages, null, null, null, null].slice(0, 4);
		return selected.map((img, index) => {
			return img || defaults[index];
		});
	},
	summaryPropertyPhotoList: (propertyDetail) => {
		const selectedImages = propertyDetail.selectedImages || [];
		return [...selectedImages, null, null, null, null].slice(0, 4);
	},
};

export default PropertyDetailImages;
